import { Button, Card, ControlGroup, Elevation } from "@blueprintjs/core";
import React from "react";
import { inject, observer } from "mobx-react";
import _ from "lodash";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import { LicenseManager } from "ag-grid-enterprise";
import "ag-grid-enterprise";
import pdfMake from "pdfmake";
import PDFExportPanel from "./pdfExport/PDFExportPanel";

LicenseManager.setLicenseKey(
  "CompanyName=Radical Health-Tech Private Limited,LicensedGroup=NewChart,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-039334,SupportServicesEnd=30_January_2024_[v2]_MTcwNjU3MjgwMDAwMA==4e3339807505d27fad23ae4460ff0f81"
);

class MasterGrid extends React.Component {
  state = {
    gridApi: null,
    columnApi: null,
    quickFilterText: null,
    aggregations: {
      sum: (params) => this.sumAggregation(params),
      average: (params) => this.averageAggregation(params),
      max: (params) => this.maxAggregation(params),
      min: (params) => this.minAggregation(params),
      count: (params) => this.countAggregation(params),
    },
    changed: false,
  };

  formatText = (params) => {
    if (params === "NA") {
      return "";
    }
    return _.startCase(_.lowerCase(params));
  };

  formatCurrency = (params) => {
    let num = Number(params.value / 100);
    return num.toLocaleString("en-IN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      style: "currency",
      currency: "INR",
    });
  };

  sumAggregation = (params) => {
    let arr = _.map(params.values, (each) => Number(each));
    arr = arr.filter((value) => !Number.isNaN(value));
    return _.sum(arr);
  };

  averageAggregation = (params) => {
    let arr = _.map(params.values, (each) => Number(each));
    arr = arr.filter((value) => !Number.isNaN(value));
    return _.mean(arr);
  };

  maxAggregation = (params) => {
    let arr = _.map(params.values, (each) => Number(each));
    arr = arr.filter((value) => !Number.isNaN(value));
    return _.max(arr);
  };

  minAggregation = (params) => {
    let arr = _.map(params.values, (each) => Number(each));
    arr = arr.filter((value) => !Number.isNaN(value));
    return _.min(arr);
  };

  countAggregation = (params) => {
    return params.values.length;
  };

  onGridReady = (params) => {
    // console.log("Grid is ready!", params);

    this.setState({ gridApi: params.api, columnApi: params.columnApi });
  };
  getHeaderToExport = () => {
    const columns = this.state.gridApi.getAllDisplayedColumns();

    return columns.map((column) => {
      const { field } = column.getColDef();
      const sort = column.getSort();
      const headerNameUppercase = field[0].toUpperCase() + field.slice(1);
      const headerCell = {
        text: headerNameUppercase + (sort ? ` (${sort})` : ""),
      };
      return headerCell;
    });
  };
  getRowsToExport = () => {
    const columns = this.state.gridApi.getAllDisplayedColumns();

    const getCellToExport = (column, node) => ({
      text: this.state.gridApi.getValue(column, node) ?? "",
    });

    const rowsToExport = [];
    this.state.gridApi.forEachNodeAfterFilterAndSort((node) => {
      const rowToExport = columns.map((column) =>
        getCellToExport(column, node)
      );
      rowsToExport.push(rowToExport);
    });

    return rowsToExport;
  };

  getDocument = () => {
    const columns = this.state.gridApi.getAllDisplayedColumns();

    const headerRow = this.getHeaderToExport();
    const rows = this.getRowsToExport();

    return {
      pageOrientation: "landscape", // can also be 'portrait'
      content: [
        {
          table: {
            // the number of header rows
            headerRows: 1,

            // the width of each column, can be an array of widths
            widths: `${100 / columns.length}%`,

            // all the rows to display, including the header rows
            body: [headerRow, ...rows],

            // Header row is 40px, other rows are 15px
            heights: (rowIndex) => (rowIndex === 0 ? 40 : 15),
          },
        },
      ],
    };
  };
  exportToPDF = () => {
    const doc = this.getDocument(this.state.gridApi);
    pdfMake.createPdf(doc).download();
  };

  render() {
    return (
      <div
        className="ag-theme-alpine-dark axis"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            textAlign: "right",
            marginRight: "55px",
            padding: "1rem 0rem 1rem 1rem",
          }}
        >
          <PDFExportPanel
            typeOfGrid={this.props.typeOfGrid}
            gridApi={this.state.gridApi}
            columnApi={this.state.columnApi}
          />
        </div>

        <Card
          style={{
            width: "90vw",
            height: "80vh",
            margin: "auto",
            padding: "0px",
          }}
          elevation={Elevation.FOUR}
        >
          <AgGridReact
            defaultColDef={{
              sortable: true,
              filter: true,
            }}
            ref="reportGrid"
            rowGroupPanelShow="always"
            suppressDragLeaveHidesColumns={true}
            suppressMakeColumnVisibleAfterUnGroup={true}
            quickFilterText={this.state.quickFilterText}
            cacheQuickFilter={true}
            groupMultiAutoColumn={true}
            columnDefs={this.props.columnDefs}
            rowData={this.props.loadedItems}
            rowSelection="multiple"
            rowDragManaged={true}
            enableCharts={true}
            enableRangeSelection={true}
            chartThemes={[
              "ag-default-dark",
              "ag-material-dark",
              "ag-pastel-dark",
              "ag-vivid-dark",
              "ag-solar-dark",
            ]}
            onGridReady={this.onGridReady}
            enableCellTextSelection={true}
            ensureDomOrder={true}
            enableRangeHandle={true}
            aggFuncs={this.state.aggregations}
            sideBar={true}
            statusBar={{
              statusPanels: [
                {
                  statusPanel: "agTotalAndFilteredRowCountComponent",
                  align: "left",
                },
                {
                  statusPanel: "agSelectedRowCountComponent",
                  align: "left",
                },
                {
                  statusPanel: "agAggregationComponent",
                  align: "right",
                },
              ],
            }}
          />
        </Card>
      </div>
    );
  }
}

export default inject("authStore")(observer(MasterGrid));
